export default {
  name: 'deployProgress',

  getReducer: () => {
    const initialData = {
      state: null, // 'building' | 'succeeded' | 'failed' | null
      deployId: null,
      deployBranch: null,
      title: null,
      commitRef: null,
      currentBranch: process.env.REACT_APP_BRANCH || 'local',
      dismissed: false,
    };

    return (state = initialData, { type, payload }) => {
      if (type === 'DEPLOY_PROGRESS_EVENT') {
        return {
          ...state,
          state: payload.state,
          deployId: payload.deployId,
          deployBranch: payload.branch,
          title: payload.title,
          commitRef: payload.commitRef,
          dismissed: false,
        };
      }
      if (type === 'DEPLOY_PROGRESS_DISMISSED') {
        return { ...state, dismissed: true };
      }
      return state;
    };
  },

  doDeployProgressEvent:
    event =>
    ({ dispatch, getState, store }) => {
      const authedUser = store.selectAuthenticatedUser(getState());
      if (!authedUser?.isAuthorized('ui.split.test')) return;
      if (!event || !event.state) return;

      const { currentBranch } = getState().deployProgress;
      const isCurrentBranch = event.branch === currentBranch;

      // Building / failed only fire for the user's own build. Succeeded fires
      // for any branch — the toast offers Reload (own branch) or Switch
      // (different branch).
      if (
        (event.state === 'building' || event.state === 'failed') &&
        !isCurrentBranch
      ) {
        return;
      }

      dispatch({ type: 'DEPLOY_PROGRESS_EVENT', payload: event });
    },

  doDevSimulateDeploy:
    (state, overrides = {}) =>
    ({ dispatch, getState }) => {
      const { currentBranch } = getState().deployProgress;
      dispatch({
        type: 'DEPLOY_PROGRESS_EVENT',
        payload: {
          state,
          deployId: 'dev-sim',
          branch: currentBranch,
          title: 'Dev simulation',
          commitRef: 'devdevdevdev',
          ...overrides,
        },
      });
    },

  doDismissDeployProgress:
    () =>
    ({ dispatch }) =>
      dispatch({ type: 'DEPLOY_PROGRESS_DISMISSED' }),

  doReloadForDeployProgress: () => () => {
    window.location.reload();
  },

  doSwitchToDeployBranch:
    () =>
    ({ getState }) => {
      const { deployBranch } = getState().deployProgress;
      if (!deployBranch) return;
      const expires = new Date(
        Date.now() + 1000 * 60 * 60 * 24 * 365,
      ).toUTCString();
      document.cookie = `nf_ab=${deployBranch}; expires=${expires}; path=/`;
      window.location.reload();
    },

  selectDeployProgressBranch: state => state.deployProgress.currentBranch,
  selectDeployProgressState: state =>
    state.deployProgress.dismissed ? null : state.deployProgress.state,
  selectDeployProgressIsCurrentBranch: state =>
    state.deployProgress.deployBranch === state.deployProgress.currentBranch,
  selectDeployProgressTitle: state => state.deployProgress.title,
  selectDeployProgressDeployBranch: state => state.deployProgress.deployBranch,
  selectDeployProgressCommitRef: state => state.deployProgress.commitRef,
};
